import { useCallback } from 'react';

import { usePintoEbookCollectionLazyQuery } from '../core/graphql/operation-hooks';

const useQueryPintoEbookCollection = () => {
  const [queryPintoEbookCollection, { data, loading }] = usePintoEbookCollectionLazyQuery();

  const fetchPintoEbookCollection = useCallback(
    (ebookCollectionId: string) => {
      queryPintoEbookCollection({ variables: { ebookCollectionId } });
    },
    [queryPintoEbookCollection],
  );

  return {
    fetchPintoEbookCollection,
    pintoEbookCollection: data?.pintoEbookCollection,
    isLoadingPintoEbookCollection: loading,
  };
};

export default useQueryPintoEbookCollection;
